import OnHoldIssueModal from '@/components/OnHoldIssueModal';
import { RootState } from '@/index';
import { CLSTAG, IssueStatus, IssueType } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

interface Props {
  vehicleName: string;
  disabled: boolean;
}
const OnHoldIssue = (props: Props) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<'HOLD' | 'CANCEL_HOLD'>('HOLD');
  const { vehicleName, disabled } = props;
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const currentIssue =
    issueList &&
    issueList.find(
      (issue: any) =>
        issue.vehicleName === vehicleName && issue.issueType === IssueType.OPS,
    );
  const showOnHold = currentIssue?.issueStatus === IssueStatus.PROCESS;
  const showCancelOnHold = currentIssue?.issueStatus === IssueStatus.ON_HOLD;

  return (
    <>
      <div className={currentIssue ? 'mini-item' : 'mini-item-disabled'}>
        {!currentIssue || disabled ? (
          <>
            <div className={'operate-onHold-disabled'} />
            <h3 className='operate_key'>挂单</h3>
          </>
        ) : showOnHold ? (
          <>
            <div
              className={'operate-onHold'}
              onClick={() => {
                if (disabled) {
                  return;
                }
                setOpen(true);
                setType('HOLD');
              }}
              clstag={clstagStr(CLSTAG.OnHoldIssue)}
            />
            <h3 className='operate_key'>挂单</h3>
          </>
        ) : showCancelOnHold ? (
          <>
            <div
              className='operate-cancelHold'
              onClick={() => {
                setOpen(true);
                setType('CANCEL_HOLD');
              }}
            />
            <h3 className='operate_key'>取消挂单</h3>
          </>
        ) : (
          <></>
        )}
      </div>
      <OnHoldIssueModal
        open={open}
        setOpen={setOpen}
        issueNumber={currentIssue?.issueNumber}
        type={type}
      />
    </>
  );
};
export default React.memo(OnHoldIssue);
